import React, { Component } from "react";
import Head from "next/head";
import Layout from "../../container";
import { LandingFooter } from "../../pagecomponents/Welcome";
import { Grid } from "semantic-ui-react";

class Aboutus extends Component {
  render() {
    return (
      <div className="home-wrapper">
        <Head>
          <meta charSet="UTF-8" />
          <title>Houseberry: About Us</title>
          <meta
            property="og:image"
            content={
              process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"
            }
          />
          <meta
            name="description"
            content="Learn more about Houseberry, our mission to help you discover neighborhoods, and our commitment to providing detailed, insightful neighborhood information."
          ></meta>
          <meta
            name="keywords"
            content="about Houseberry, neighborhood data, real estate information, neighborhood-first"
          ></meta>
        </Head>

        <div className="static_content_main">
          <Layout search={true} nhmap={false}>
            <Grid
              stackable
              style={{ margin: "0 auto", maxWidth: "1280px" }}
              className="detail_nh_top"
            >
              <div className="aboutus_main">
                <h1>About Us</h1>
                <p>
                  Welcome to Houseberry, the best place to find that sweet
                  neighborhood for your sweet home.
                </p>
                <p>
                  Houseberry was born from the realization that the first step
                  toward finding your dream home is actually figuring out where
                  you want to be. But where do you start, and how do you learn
                  about the unique nature of dozens of neighborhoods in your
                  search area? We have developed a powerful platform to help you
                  learn about what different neighborhoods have to offer and
                  connect you with people who work and live in these places -
                  your future neighbors
                </p>
                <p>
                  Our philosophy is as simple as it is powerful- home shoppers
                  should choose the right neighborhood first, and the perfect
                  home will follow.
                </p>
              </div>
              <div className="aboutus_common">
                <p>
                  <strong>Redefining the Home Search Experience</strong>
                </p>
                <p>
                  The starting point at Houseberry is our Neighborhood Map, a
                  unique search experience that allows you to see different
                  neighborhoods and compare them based on factors that matter
                  most to home buyers: Schools, Safety, Amenities, and Price of
                  homes. We gather and analyze data from multiple sources and
                  use advanced algorithms to determine overall Neighborhood
                  Scores to help you see how neighborhoods perform when all the
                  factors are taken into account. The Personalized Search
                  feature allows you to determine what factors are important to
                  you and rate the neighborhoods according to your preferences.
                </p>
                <p>
                  Our Map also shows you active home listings, and alerts you
                  when a new listing has come on the market in any of your
                  favorite neighborhoods.
                </p>
              </div>
              <div className="aboutus_common">
                <p>
                  <strong>Building a Connected and Inspiring Community</strong>
                </p>
                <p>
                  At Houseberry, we believe in the power of community in making
                  one of the most significant decisions in life - where to call
                  home. We invite neighbors and real estate agents who live and
                  work in these neighborhoods to provide valuable insights for
                  others. We also invite homebuyers to share your knowledge of
                  neighborhoods you know, ask questions of new neighborhoods,
                  and engage with others to make informed decisions. Help us
                  cultivate an inclusive environment where everyone can explore,
                  learn, contribute, and feel supported in searching for a home
                  or helping future neighbors find their own.
                </p>
                <p>
                  Our innovative platform offers a unique combination of data
                  technology and human insights, ensuring you have all of the
                  tools necessary to find your dream neighborhood and your dream
                  home.
                </p>
                <p>
                  Join us at Houseberry and start your journey towards finding
                  your dream place to live, or celebrating your own community.
                  Together, we’ll transform the home search process and
                  contribute to vibrant and connected communities in the
                  process.
                </p>
              </div>
            </Grid>
          </Layout>
          <LandingFooter />
        </div>
      </div>
    );
  }
}

export default Aboutus;
